<template>
  <div>
    <b-row class="mb-2">
      <b-col md="10" class="first-column">
        <h6 class="display-title">Id: {{ item.Id }}</h6>
      </b-col>
      <b-col class="text-right" md="2">
        <h4>
          <b-badge :variant="getBadgeClass(item)">
            {{item.EstadoSolicitudMedicaString}}
          </b-badge>
        </h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <small>
          <strong>Tipo:</strong>
          {{ item.TipoSolicitudMedicaString }}
        </small>
      </b-col>
      <b-col md="3">
        <small>
          <strong>Fecha de presentación:</strong>
          {{ item.FechaPresentacion | moment("DD-MM-YYYY") }}
        </small>
      </b-col>
      <b-col md="3">
        <small>
          <strong>Ausente desde:</strong>
          {{ item.FechaDesde | moment("DD-MM-YYYY") }}
        </small>
        <br>
      </b-col>
      <b-col md="3">
        <small v-if="item.EstadoSolicitudMedicaString === 'Enviado' || item.EstadoSolicitudMedicaString == 'FueraTermino' || item.EstadoSolicitudMedicaString == 'Creado'">
          <strong>Recibir antes del:</strong>
          {{ fechaVencimiento(item) }}
        </small>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <small>
          <strong>Establecimiento:</strong>
          {{ item.EnviadoHacia }}
        </small>
      </b-col>
      <b-col md="3">
        <small>
          <strong>Creada por:</strong>
          {{ item.UsuarioCargaString }}
        </small>
      </b-col>
      <b-col md="6">
        <small>
          <strong>Observaciones:</strong>
          {{ item.Observaciones ? item.Observaciones : "Sin Observaciones" }}
        </small>
      </b-col>
    </b-row>
    <b-row v-if="item.LicenciaCargoPersonal">
      <b-col cols="12">
        <strong>Licencia:</strong>
        {{item.LicenciaCargoPersonal.TipoLicencia.Articulo}} {{item.LicenciaCargoPersonal.DisplayCantidadDias}}  Desde {{item.LicenciaCargoPersonal.LicenciaDesde | moment("DD-MM-YYYY")}} Hasta {{item.LicenciaCargoPersonal.LicenciaHasta | moment("DD-MM-YYYY")}}
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col cols="10">
        <small>
          <strong>Cargos justificados:</strong>
          {{item.ListaCargoPersonalString.join(',')}}
        </small>
      </b-col>
      <b-col cols="2">
        <small>
          <strong>Ult. Act.:</strong>
          {{item.FechaModificacion | moment("DD-MM-YYYY HH:mm")}}
        </small>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "ListaSolicitudItem",
  props: {
    item: Object
  },
  watch: {
  },
  components: {
  },
  computed: {
  },
  data() {
    return {};
  },
  methods: {
    fechaVencimiento(item) {
      var start = moment(item.FechaCreacion);
      var end = moment(item.FechaCreacion).add(48, "h");
      return end.format("DD-MM-YYYY");
    },
    // TODO : En un principio retornaba un color por cada estado diferente. Ahora solo retorna success. Se debe revisar
    getBadgeClass(item) {
      switch (item.EstadoSolicitudMedicaString) {
        case "Creado":
          return "secondary";
          break;
        case "Autorizado":
          return "success";
          break;
        case "LicenciaFinalizada":
          return "success";
          break;
        case "NoAutorizado":
          return "dark";
          break;
        case "Recibido":
          return "primary";
          break;
        case "Enviado":
          return "info";
          break;
        case "FueraTermino":
          return "danger";
          break;
        case "Rechazado":
          return "danger";
          break;
        default:
          return "ligth";
      }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/ListaSolicitudItem.vue